import { makeStyles } from '@material-ui/core';
import { corFM, corGF } from 'app/utils/coresUtil';
import { CLIENTS_ID, getClientId } from 'app/utils/enviromentUtil';

export const recuperarSenhaStyles = makeStyles((theme) => ({
  logoTitulo: {
    fontWeight: 600,
    lineHeight: 1.25,
    color: corFM,
    fontFamily: 'Muli, Helvetica, sans-serif',
    [theme.breakpoints.up('sm')]: {
      fontSize: '7.0rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '3.2rem',
    },
  },
  logoImg: {
    width: '365px',
    height: '126px',
    marginLeft: getClientId() === CLIENTS_ID.financeiroFront ? '-30px' : '',
    marginBottom: '13px',
  },
  button: {
    borderRadius: '48px',
    backgroundColor: getClientId() === CLIENTS_ID.financeiroFront ? corFM : corGF,
    color: '#fff',
    border: 'none',
    width: '100%',
    height: '50px',
    textTransform: 'initial',
    '&:hover': {
      background: getClientId() === CLIENTS_ID.financeiroFront ? corFM : corGF,
    },
  },
  cardTitulo: {
    fontSize: '25px',
    fontWeight: 600,
    color: corFM,
    textAlign: 'center',
  },
  linkVoltar: {
    textAlign: 'center',
  },
}));
